<template>
  <div class="flex h-screen w-full bg-gray-100">

    <!-- SIDEBAR ESQUERDA -->
    <aside class="w-72 bg-white border-r border-gray-200 p-6">
  <h2 class="text-lg font-semibold mb-6">Caixa de atendimento</h2>

  <!-- Lista de agendamentos -->
  <div class="flex flex-col gap-4">
    <button
      v-for="agendamento in agendamentos"
      :key="agendamento.id"
      class="text-left font-medium text-gray-900"
      @click="handleAgendamentoSelecionado(agendamento.id)"
    >
      {{ agendamento.nome ?? 'Sem nome' }}
    </button>
  </div>

  <!-- Paginação -->
  <div class="flex flex-col gap-2 mt-10">
    <button
      class="text-left font-medium text-gray-900"
      :disabled="!agendamentosPrevPageUrl"
      @click="carregarPagina('anterior')"
    >
      ⬅️ Página anterior
    </button>

    <button
      class="text-left font-medium text-gray-900"
      :disabled="!agendamentosNextPageUrl"
      @click="carregarPagina('proxima')"
    >
      ➡️ Próxima página
    </button>
  </div>
</aside>


    <!-- LISTA CENTRAL -->
    <div class="w-100 border-r border-gray-200 bg-white flex flex-col">

      <!-- Header -->
      <div class="p-4 border-b border-gray-200">
        <h1 class="text-xl font-semibold mb-4">Você</h1>

        <!-- Filtros -->
        <div class="flex items-center gap-3 mb-4">
          <span
            class="px-3 py-1 rounded-full text-sm font-medium cursor-pointer"
            :class="aba === 'abertos' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'"
            @click="aba = 'abertos'"
          >
            Abertos
          </span>

          <span
            class="px-3 py-1 rounded-full text-sm font-medium cursor-pointer"
            :class="aba === 'pendentes' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'"
            @click="aba = 'pendentes'"
          >
            Pendentes
          </span>

          <span
            class="px-3 py-1 rounded-full text-sm font-medium cursor-pointer"
            :class="aba === 'fechados' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'"
            @click="aba = 'fechados'"
          >
            Fechados
          </span>

          <span
            class="px-3 py-1 rounded-full text-sm font-medium cursor-pointer"
            :class="aba === 'prioridade' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'"
            @click="aba = 'prioridade'"
          >
            Prioridade
          </span>
        </div>

        <!-- Barra de busca -->
        <div class="relative mb-4">
          <input
            type="text"
            placeholder="Pesquise por nome, telefone ou e-mail"
            class="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500"
          />
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 absolute right-3 top-2.5 text-gray-400" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z" />
          </svg>
        </div>

        <!-- Ordenação -->
        <div class="flex justify-between items-center">
          <div>
            <label class="block text-xs text-gray-500">Ordenar por:</label>
            <select
              class="border border-gray-300 rounded-md px-2 py-1 text-sm"
            >
              <option>Mais novos</option>
              <option>Mais antigos</option>
            </select>
          </div>

          <div>
            <label class="block text-xs text-gray-500">Visualizar</label>
            <select
              class="border border-gray-300 rounded-md px-2 py-1 text-sm text-gray-800"
            >
              <option>Tudo</option>
              <option>Bloqueio</option>
              <option>Venda por campanha</option>
              <option>Inativo</option>
              <option>Não interessado</option>
              <option>Esperando resposta</option>
              <option>Sem meio de contato</option>
              <option>Dados incorretos</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Lista -->
      <div
        v-for="p in pessoas"
        :key="p.id"
        @click="abrirChat(p)"
        class="flex items-center gap-3 px-4 py-3 border-b border-gray-200 cursor-pointer hover:bg-gray-100"
      >
        <div class="h-10 w-10 rounded-full bg-gray-300 flex items-center justify-center font-semibold text-gray-700">
           {{ p.nome[0].toUpperCase() }}
        </div>

        <div class="flex flex-col">
          <span class="font-medium text-gray-900">{{ p.nome}}</span>
          <span class="text-sm text-gray-500">{{ p.status }}</span>
        </div>
      </div>
    </div>

    <!-- PAINEL DIREITO -->
    <div class="flex-1 flex flex-col" v-if="contatoSelecionado">

      <!-- Topo com nome -->
      <div class="p-4 border-b bg-white border-gray-300 font-semibold">
        {{ contatoSelecionado.nome }}
      </div>

      <!-- Mensagens -->
      <div class="flex-1 overflow-y-auto p-4 space-y-3">
        <div
          v-for="m in mensagens"
          :key="m.id"
          :class="m.isCliente ? 'text-left' : 'text-right'"
        >
          <span
            class="inline-block px-4 py-2 rounded-lg"
            :class="m.isCliente
              ? 'bg-gray-200 text-gray-800'
              : 'bg-indigo-600 text-white'"
          >
            {{ m.texto }}
          </span>
        </div>

        <!-- Estado vazio -->
        <div v-if="mensagens.length === 0" class="text-center text-gray-400 mt-10">
          Nenhuma mensagem ainda. Inicie a conversa.
        </div>
      </div>

      <!-- Input desativado (somente visual) -->
      <div class="p-4 border-t border-gray-300 bg-white">
        <form @submit.prevent="onSendFormData" class="flex items-center gap-2">
          <input
            v-model="novaMensagem"
            type="text"
            placeholder="Digite sua mensagem"
            class="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500"
            :disabled="loading"
          />

          <button
            type="submit"
            :disabled="loading || !novaMensagem.trim()"
            class="px-4 py-2 rounded-md bg-indigo-600 text-white font-medium
                  hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Enviar
          </button>
        </form>
      </div>
    </div>

    <!-- Placeholder quando não selecionou -->
    <div v-else class="flex-1 flex flex-col items-center justify-center text-gray-600">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14 text-gray-400 mb-4" fill="none"
        viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8l-4 1 1.1-3.2A7.922 7.922 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>

      <h3 class="text-lg font-semibold">Comece a falar com seus contatos!</h3>
      <p class="text-sm text-gray-500 mt-1">Selecione um contato na lista ao lado.</p>
    </div>

  </div>
</template>

<script>

import { pageVariables } from '@/views/insideviews/atendimentos_whats_app/PageVariablesAtendimentosWhatsApp';
import AtendimentoWhatsappRepository from '@/services/AtendimentoWhatsappRepository.vue';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import ListaDeAgendamentosRepository from '@/services/ListaDeAgendamentosRepository.vue';
import Pusher from 'pusher-js';

export default {
  name: "AtendimentoView",
  async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.getLista(this.listaDeAgendamentoPage);
	},
  data() {
    return {
      menuSelected: "voce",
      aba: "abertos",
      ...pageVariables,
      contatoSelecionado: null,
      loading: false,
      agendamentos: [],
			agendamentosNextPageUrl:"",
			agendamentosPrevPageUrl:"",
      listasWhats: [],
      listasWhatsNextPageUrl:"",
			listasWhatsPrevPageUrl:"",
      onlineUser:{},
      pessoas: [],
      mensagens: [],
      novaMensagem: "",
      conversaId: null,
      pusher: null,
      canalAtendente: null,
      canalPrioridade: null,
    };
  },

   mounted() {
    this.initBroadcast();
  },

  methods: {
    async getLista(page){
			this.loading = true; 
			const listasRepo = new AtendimentoWhatsappRepository();
			try {
				const response = await listasRepo.getAgendamentos(this.onlineUser.token,page);
				if (response?.status  === 200) {
          console.log(response.data.data)
					this.agendamentos = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

				if (response.data.next_page_url) {
					this.agendamentosNextPageUrl = response.data.next_page_url;
					console.log(this.agendamentosNextPageUrl)
				}else{
					this.agendamentosNextPageUrl = ""
				}
				if (response.data.agendamentosPrevPageUrl) {

					this.agendamentosPrevPageUrl = response.data.prev_page_url;
				}else{
					this.preagendamentosPrevPageUrlvious = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error); 
			}
		},
    handleAgendamentoSelecionado(id){
      this.getListaWhatsApp(id);
    },
    async getListaWhatsApp(id){
			this.loading = true; 
			const listasRepoWhatsRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listasRepoWhatsRepo.getListaWhatsApp(id,this.onlineUser.token);
				if (response?.status  === 200) {
          console.log(response.data.data)
					this.pessoas = response.data.data.map(item => {
            const origem = item.segurado ?? item.dependentes

            if (!origem) return null

            return {
              id: item.id,
              nome: origem.nome,
              telefone: origem.telefone,
              status: item.status
            }
          }).filter(Boolean)
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
				if (response.data.next_page_url) {
					this.listasWhatsNextPageUrl = response.data.next_page_url;
					console.log(this.listasWhatsNextPageUrl)
				}else{
					this.listasWhatsNextPageUrl = ""
				}
				if (response.data.listasWhatsPrevPageUrl) {

					this.listasWhatsPrevPageUrl = response.data.prev_page_url;
				}else{
					this.listasWhatsPrevPageUrl = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error); 
			}
		},
    abrirChat(contato) {
      this.getMensagens(contato.id);
      this.contatoSelecionado = contato;
      /*
      this.mensagens = [
        { id: 1, autor: "cliente", texto: "Oi, tudo bem?" },
        { id: 2, autor: "agente", texto: "Tudo ótimo! Como posso ajudar?" },
        { id: 3, autor: "cliente", texto: "Queria saber sobre um seguro..." },
      ];*/
    },
    async onSendFormData(){
			const listasRepo = new AtendimentoWhatsappRepository();
      console.log(this.contatoSelecionado);
      const payload = {
        conversa_id: this.conversaId ?? "", // 👈 AQUI
        lista_agendamento_id: this.contatoSelecionado.id,
        mensagem: this.novaMensagem,
        cliente_id: this.contatoSelecionado.telefone.replace(/\D/g, '')
      };

      this.loading = true;
			try {
				console.log(payload)
				const response = await listasRepo.createMensagem(payload,this.onlineUser.token);
        const body = response.data?.response?.body ?? this.novaMensagem;

        this.mensagens.push({
          id: response.data.twilio_id,
          texto: body,
          autor: this.onlineUser.email,
          isCliente: false,
          created_at: new Date().toISOString()
        });

        this.novaMensagem = "";
        } catch (error) {
          handleUnauthorized(error); 
        }	
		},
    async getMensagens(id){
			this.loading = true; 
			const listasRepo = new AtendimentoWhatsappRepository();
			try {
				const response = await listasRepo.getConversas(id,this.onlineUser.token);
				if (response?.status  === 200) { 
          const conversa = response.data;

          if (conversa) {
            this.conversaId = conversa.id;

            this.mensagens = (conversa.mensagens ?? []).map(m => {
            
              return {
                id: m.id,
                texto: m.conteudo,
                autor: m.autor,
                isCliente: m.autor === 'cliente',
                created_at: m.created_at
              };
            });
          } else {
            this.conversaId = null;
            this.mensagens = [];
          }
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error); 
			}
		},
    handleMenuChange(tipo) {
      this.menuSelected = tipo;

      if (tipo === "voce") {
        this.listarVoce();
      } else if (tipo === "nao_atribuido") {
        this.listarNaoAtribuidos();
      } else {
        this.listarTodos();
      }

      this.contatoSelecionado = null;
    },

    sanitizeChannel(value) {
      if (!value) return null;

      return value
        .toLowerCase()
        .replace(/@/g, "__at__")
        .replace(/\./g, "__dot__")
        .replace(/[^a-z0-9_-]/g, "");
    },

    initBroadcast() {
      
      const APP_KEY = "dyc3c50p6e9uiibkg2br";

      this.pusher = new Pusher(APP_KEY, {
        wsHost: "justechv2.sienaseguros.com.br",
        wssPort: 443,
        forceTLS: true,
        disableStats: true,
        cluster: "mt1",
        enabledTransports: ["wss"],
      });

      this.pusher.connection.bind("connected", () => {
        console.log("✅ Conectado ao Reverb");
      });

      this.pusher.connection.bind("error", (err) => {
        console.error("❌ Erro Reverb", err);
      });

      // 🔹 canal do atendente
      const email = this.onlineUser.email;
      const canalEmail = this.sanitizeChannel(email);

      this.canalAtendente = this.pusher.subscribe(`atendente.${canalEmail}`);
      this.canalPrioridade = this.pusher.subscribe("prioridade");

      // escuta mensagens normais
      this.canalAtendente.bind("mensagem.recebida", this.onMensagemRecebida);

      // escuta mensagens prioritárias
      this.canalPrioridade.bind("mensagem.recebida", this.onMensagemPrioridade);
    },

    listarVoce() {
      this.pessoas = [
        { id: 1, nome: "Aline" },
        { id: 2, nome: "Luis" },
      ];
    },

    listarNaoAtribuidos() {
      this.pessoas = [
        { id: 5, nome: "Cliente Novo" },
        { id: 6, nome: "Visitante" },
      ];
    },

    listarTodos() {
      this.pessoas = [
        { id: 1, nome: "Aline" },
        { id: 2, nome: "Luis" },
        { id: 5, nome: "Cliente Novo" },
        { id: 6, nome: "Visitante" },
      ];
    },
  },
};
</script>
